import { getService } from 'reducers/service';
import ServiceName from '../constants/serviceName';

export const getUserGridLayout = async (gridKey) => {
  const service = getService(ServiceName.rms_user_grid_layout);
  const response = await service.find({
    query: {
      GridKey: gridKey,
      IsDeleted: false,
      $limit: 1,
    },
  });

  const data = response?.data || [];
  return data[0] || null;
};

export const saveUserGridLayout = async (gridKey, layout) => {
  const service = getService(ServiceName.rms_user_grid_layout);
  const response = await service.create({
    GridKey: gridKey,
    ...layout,
  });

  return response?.data || response;
};

export const resetUserGridLayout = async (gridKey) => {
  const service = getService(ServiceName.rms_user_grid_layout);
  return service.remove(null, {
    query: { GridKey: gridKey },
  });
};

export default {
  getUserGridLayout,
  saveUserGridLayout,
  resetUserGridLayout,
};